import styled from "styled-components";

import { DATA_E2E_TEMPLATE_KEY, type IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const StyledPhoneTemplate = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_TEMPLATE_KEY]: "phone-template",
})`
  position: relative;
  display: flex;
  width: 100%;
  gap: 8px;

  .phoneIcon {
    transform: translateY(60%);
    margin-inline-start: 16px;
    cursor: pointer;

    &.phoneIconActive {
      color: ${rydeColors.steel};
    }

    &.phoneIconDisabled {
      color: ${rydeColors.grey};
    }
  }
`;
